import axios from '@/plugins/request'

export default {
  query(kw, filter, sort, pageNum, pageSize) {
    return axios({
      url: '/Customers/',
      method: 'GET',
      params: {
        kw: kw,
        filter: encodeURI(JSON.stringify(filter)),
        sort: encodeURI(JSON.stringify(sort)),
        pageNum: pageNum,
        pageSize: pageSize
      }
    })
  },

  getById(id) {
    return axios({
      url: '/Customers/' + id,
      method: 'GET'
    })
  },

  save(po) {
    return axios({
      url: '/Customers/' + (po.id ? po.id : ''),
      method: po.id ? 'PUT' : 'POST',
      data: po
    })
  },

  delete(id) {
    return axios({
      url: '/Customers/' + id,
      method: 'DELETE'
    })
  },

  updateMyInfo(cst) {
    return axios({
      url: '/Customers/myInfo',
      method: 'PUT',
      data: cst
    })
  }
}
